import React from 'react'
import { ApiError } from '../../shared/types/apiError.type'
import { isString } from 'lodash'
import { Alert } from '@mui/material'
import { t } from 'i18next'

type errorProps = {
  isError: boolean,
  error: ApiError
}

function Errors({ isError, error }: errorProps) {

  if (!isError) return <></>
  return <Alert sx={{ my: 2 }} severity='error'>{error?.message ?? error?.description ?? t('error:generic')}</Alert>
}

export default Errors